import { render, staticRenderFns } from "./AllowMicrophone.vue?vue&type=template&id=1753c28a"
import script from "./AllowMicrophone.vue?vue&type=script&lang=js"
export * from "./AllowMicrophone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports